module.exports = __webpack_public_path__ + "static/media/optionq-banner.dfce0522.png";